import React from "react";
import ADKAgentBuilder from "../adk-agent-builder/App";

/**
 * AgentBuilderPage - New visual flow-based ADK Agent Builder
 * 
 * This component wraps the ADK Agent Builder which provides a 
 * drag-and-drop canvas for building agent workflows.
 * 
 * The old form-based agent builder has been preserved in AgentBuilderPage.old.tsx
 */
const AgentBuilderPage: React.FC = () => {
    return <ADKAgentBuilder />;
};

export default AgentBuilderPage;
